import { Component, OnInit } from '@angular/core';
import { ToastNotificationService } from 'app/shared/toast-notification/toast-notification.service';
import { INT_WFROUTES_ACTIONS, WFROUTES_ACTIONS } from "app/shared/actions/actions.constants";
import { ConfirmDialogService } from "app/services/shared/confirm-dialog/confirm-dialog.service";
import { WorkflowService } from 'app/services/workflow.service';
import { UtilityServiceService } from 'app/services/utility-service.service';
import { routesdto } from 'app/models/routesdto';
import { AuthWebService } from 'app/services/authweb.service';
import { DatePipe } from '@angular/common';


@Component({
  selector: 'app-wfroutes',
  templateUrl: './wfroutes.component.html',
  styleUrls: ['./wfroutes.component.scss']
})
export class WFRoutesComponent implements OnInit {
  routesdto: routesdto = new routesdto;
  wfroutetypes: any;
  authwebroles:any;
  wfstatuses: any;
  wfactions:any;
  routes: any = [];
  selectedData: any = null;
  selectedStatusData: any = null;
  isLoading: boolean = false;
  lblHeading = "Manage Route Type";
  user: any = {};
  mode:any = 'Add';

  WFRouteActions = INT_WFROUTES_ACTIONS;

  //#region Paging
  page = 1;
  pageSize: number = 5;
  currentPage = 1;
  //#endregion

  constructor(private service: WorkflowService, private toaster: ToastNotificationService, 
    private authWebService: AuthWebService, private datePipe: DatePipe,
    public utility: UtilityServiceService, private dialog: ConfirmDialogService) { }

  ngOnInit(): void {
    this.user = this.authWebService.userData.User
    this.getLookupData();
    this.utility.page = 1;
  }

  //#region General

  getLookupData(){
    this.getRouteType();
    this.getWFStatuses();
    this.getWFActions(); 
    this.getAuthWebRoles();   
  }

  async getRouteType(){
    this.isLoading = true;
    await this.service.getWorkflowRouteType().subscribe(
      (result) => {
        console.log(result)
        this.wfroutetypes = result;
      },
      (error) => {
        this.isLoading = false;
      }
    );
  }

  async getWFStatuses(){
    this.isLoading = true;
    await this.service.getWorkflowStatus().subscribe(
      (result) => {
        this.wfstatuses = result;
      },
      (error) => {
        this.isLoading = false;
      }
    );
  }

  async getWFActions(){
    this.isLoading = true;
    await this.service.getWorkflowAction().subscribe(
      (result) => {
        this.wfactions = result;
      },
      (error) => {
        this.isLoading = false;
      }
    );
  }

  async getAuthWebRoles(){
    await this.authWebService.getRegisterRoles();
    await this.authWebService.getRegisterRolesObservable().subscribe((result) => {
      this.authwebroles = result;
      this.getRoutes(this.utility.page, this.pageSize);
    });
  }

  onChecked(event, item){
    if (event.target.checked) {
      this.selectedStatusData = item;
    } else {
      this.selectedStatusData = null;
    }
  }

  doRoutesAction(event: any) {
    const button = document.getElementById("popupButton") as HTMLButtonElement;
    if (event.value == WFROUTES_ACTIONS.AddWFRoute) {
      this.lblHeading = "Add Route";
      this.mode = 'Add';
      this.routesdto = new routesdto;
      button.click();
    } else if (event.value == WFROUTES_ACTIONS.DeleteWFRoute) {
      if(this.selectedStatusData == null){
         this.toaster.error("Please select the record first!","Delete")
       }else{
        this.routesdto = this.selectedStatusData;
         this.onDelete();
       }
    } else if (event.value == WFROUTES_ACTIONS.EditWFRoute) {
      this.lblHeading = "Edit Route";
      this.mode = 'Edit';
      if(this.selectedStatusData == null){
        this.toaster.error("Please select the record first!","Edit")
      }else{
        this.routesdto = this.selectedStatusData;
        button.click();
      }
    }
  }
  //#endregion

  //#region CRUD
  getRoutes(page: number = 1, pageSize: number = 5){
    this.isLoading = true;
    this.service.getWorkflowRoutesPaging(page, pageSize).subscribe(
      (result) => {
        this.onMapRoutes(result);
        this.isLoading = false;
      },
      (error) => {
        this.toaster.error(
          "Failed to load route types. Please try again",
          "Workflow Status"
        );
        this.isLoading = false;
      }
    );

  }

  onMapRoutes(result){
    var count = 0;
    result.data.forEach((item:any) => {
      console.log(this.wfroutetypes)
      console.log(item)

        const object = {
          routesid: item.routesid,
          usercreated: item.usercreated,
          datecreated: item.datecreated,
          userupdated: item.userupdated,
          dateupdated: item.dateupdated,
          deletedyn: item.deletedyn,
          routetypeid: item.routetypeid,
          routetype: this.wfroutetypes.find((p:any) => p.id==item.routetypeid).name,
          rolefromid: item.rolefromid,
          rolefrom: this.authwebroles.find((p:any) => p.Id==item.rolefromid).Name,
          roletoid: item.roletoid,
          roleto: this.authwebroles.find((p:any) => p.Id==item.roletoid).Name,
          tostatusid: item.tostatusid,
          tostatus: this.wfstatuses.find((p:any) => p.id==item.tostatusid).status,
          actionid: item.actionid,
          action: this.wfactions.find((p:any) => p.id==item.actionid).name,
          priority: item.priority,
          externalrouteyn: item.externalrouteyn
        };

        this.routes.push(object);
    });

  }

  onAdd(){

    this.routesdto.usercreated = this.user.Id;
    this.routesdto.datecreated = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    this.routesdto.userupdated = this.user.Id;
    this.routesdto.dateupdated = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    this.routesdto.deletedyn = false;

    this.isLoading = true;
    this.service.addWorkflowRouteType(this.routesdto).subscribe(
      (result) => {
        const button = document.getElementById("popupButton") as HTMLButtonElement;
        button.click();
        this.toaster.success("Route Type successfully added","Route Type");
        this.getRoutes(this.utility.page, this.pageSize);
      },
      (error) => {
        this.toaster.error(
          "Failed to save action. Please try again",
          "Workflow Route Type"
        );
        this.isLoading = false;
      }
    );
  }

  onUpdate(){

    this.isLoading = true;
    this.service.updateWorkflowRouteType(this.routesdto.routetypesid, this.routesdto).subscribe(
      (result) => {
        const button = document.getElementById("popupButton") as HTMLButtonElement;
        button.click();
        this.toaster.success("Route Type successfully updated","Route Type");
        this.getRoutes(this.utility.page, this.pageSize);
      },
      (error) => {
        this.toaster.error(
          "Failed to update action. Please try again",
          "Workflow Route Type"
        );
        this.isLoading = false;
      }
    );
  }

  onDelete(){
    this.dialog.confirmThis(`Are you sure you want to delete this route.`,
    () => {
      this.isLoading = true;      
      this.service.deleteWorkflowRouteType(this.routesdto.routetypesid).subscribe(
        (result) => {
          this.toaster.success("Route Type successfully deleted","Route Type");
          this.getRoutes(this.utility.page, this.pageSize);
        },
        (error) => {
          this.toaster.error(
            "Failed to update action. Please try again",
            "Workflow Route Type"
          );
          this.isLoading = false;
        }
      );
    },
    () => {
      this.isLoading = false;
      return;
    }
  );

  }
  //#endregion

  //#region Paging
    onChange = (event) => {
      this.currentPage = 1;
      this.pageSize = event;
      this.getRoutes(1,this.pageSize);
    };

    pager(event) {
      this.page = event;
    }
      
    onNextOrPrevious(page: number = 1) {
      this.getRoutes(page,this.pageSize);
      this.currentPage = page;
      return page;
    }
  //#endregion
}
